import styled, { css } from 'styled-components'

const PaginationContainer = styled.div`
    width: 24px;
    height: 24px;
    position: absolute;
    top: 50%;
    display: block;
    padding: 0;
    transform: translate(0, -50%);
    cursor: pointer;
    color: transparent;
    border: none;
    outline: none;
    background: transparent;

    ${props =>
        props.visible &&
        css`
            visibility: hidden;
        `}
`

export const PaginationLeftContainer = styled(PaginationContainer)`
    left: -25px;
`

export const PaginationRightContainer = styled(PaginationContainer)`
    right: -25px;
`

export const PaginationImage = styled.img`
    max-width: 100%;
`
